import React from 'react';
import {
    FacebookShareButton,
    TwitterShareButton,
    LinkedinShareButton,
    FacebookIcon,
    TwitterIcon,
    LinkedinIcon
} from 'react-share';

const PUBLIC_SITE = 'https://www.mof.gov.tl';

/**
 * Shared links always point at the public site (https://www.mof.gov.tl), never at a Netlify preview
 * or build address or the bare mof.gov.tl, so every share of a page uses the same address.
 */
export function toPublicUrl(value) {
    try {
        const parsed = new URL(value, PUBLIC_SITE);
        const host = parsed.hostname;
        if (!host.endsWith('.netlify.app') && host !== 'mof.gov.tl') return parsed.toString();
        return `${PUBLIC_SITE}${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch {
        return value;
    }
}

const SocialShare = ({ url, title, size = 32 }) => {
    const shareUrl = toPublicUrl(url || window.location.href);
    const shareTitle = title || 'Check this out!';

    return (
        <div style={{ display: 'flex', gap: '10px', marginTop: '10px' }}>
            <FacebookShareButton url={shareUrl} quote={shareTitle}>
                <FacebookIcon size={size} round />
            </FacebookShareButton>

            <TwitterShareButton url={shareUrl} title={shareTitle}>
                <TwitterIcon size={size} round />
            </TwitterShareButton>

            <LinkedinShareButton url={shareUrl} title={shareTitle}>
                <LinkedinIcon size={size} round />
            </LinkedinShareButton>
        </div>
    );
};

export default SocialShare;
